import React from 'react'

import {
  Container,
  BoxContainer,
  H5,
  Button,
  InfoWrapper,
  InfoCard,
  Titulo,
  Information,
  BookIcon,
  OpenBookIcon,
  TeacherIcon,
  ButtonBottom,
  Star,
  ArrowCurvey,
  CurlyBg,
  Color,
  Title2,
  SubTitle2,
  SubTitle3,
  SubTitle4,
  SubTitle5,
  PrimaryColor,
  InfoBox,
  TextInfoBox,
  ClassroomVector
} from './styles'

import { RotatingTitle } from '../components/RotateText'

export default function Home() {
  return (
    <Container id="home" styles={{ marginTop: "30px" }}>
      <BoxContainer>
        <RotatingTitle StarComponent={<Star />} />
        <H5>
          Inglês e espanhol para crianças, adolescentes e adultos. <br />
          Online e presencial.
        </H5>
        <Button>
          <a
            href="https://wa.me/5511999610535"
            target="blank"
            style={{
              textDecoration: "none",
              color: "white",
            }}
          >
            Clique para uma aula teste!
          </a>
        </Button>
        <ArrowCurvey />

        <ClassroomVector />
      </BoxContainer>

      <CurlyBg />
      <InfoBox>
        <Title2>
          Making the world <Color>our place!</Color>
        </Title2>
        <SubTitle2>
          Haciendo del mundo<PrimaryColor>nuestro lugar!</PrimaryColor>
        </SubTitle2>
        <SubTitle3>
          Fazendo do mundo<PrimaryColor>o nosso lugar!</PrimaryColor>
        </SubTitle3>
        <SubTitle4>
          Faire du monde<PrimaryColor>notre maison</PrimaryColor>
        </SubTitle4>
        <SubTitle5>
          Rendere il mondo<PrimaryColor>il nostro posto</PrimaryColor>
        </SubTitle5>
        <TextInfoBox>
          A  <strong>Our Place/ Nuestro Lugar</strong> é uma escola de idiomas que combina metodologia personalizada, acompanhamento individual e abordagem afetiva e lúdica para que você aprenda inglês, espanhol, italiano, francês e português com significado e resultados reais.
          <br/>
          <br/>
          Aqui, o aprendizado é adaptado ao seu objetivo (carreira, estudos, viagens), à sua faixa etária e ao seu estilo de aprendizagem (presencial ou online).

        </TextInfoBox>
      </InfoBox>

      {/* INFOS */}
      <InfoWrapper>
        <InfoCard>
          <BookIcon />
          <Titulo><strong>Experiência de aprendizagem envolvente</strong></Titulo>
          <Information>
            Focamos em transformar o aprendizado em uma experiência envolvente e prazerosa, em que estudar deixa de ser uma obrigação e passa a fazer parte da rotina. Estimulamos a motivação e a ambição do aluno como motor do seu desenvolvimento na aprendizagem de todos os idiomas: inglês, espanhol, italiano francês ou português, garantindo evolução contínua e resultados consistentes.
          </Information>
        </InfoCard>

        <InfoCard>
          <OpenBookIcon />
          <Titulo>
            <strong>Ensino do idioma em contextos reais!</strong>
          </Titulo>
          <Information>
            Atendemos desde quem vai começar do zero até quem já teve aulas de inglês e espanhol na escola. O foco é aprender a se comunicar de forma natural, como o idioma é usado no dia a dia por falantes nativos. Trabalhamos todos os idiomas (inglês, espanhol, francês e italiano) em contextos reais, por meio de músicas, leituras e prática de comunicação oral, ampliando o vocabulário e a compreensão da língua. Sem decoreba ou bloqueios: o objetivo é aprender o idioma real, com mais confiança e fluência.
          </Information>
        </InfoCard>

        <InfoCard>
          <TeacherIcon />
          <Titulo>
            <strong>Aulas personalizadas individuais ou em grupo</strong>
          </Titulo>
          <Information>
            Planejamos cuidadosamente aulas personalizadas do idioma escolhido (inglês, espanhol, francês e italiano) para cada faixa etária, com abordagens efetivas que estimulam o interesse e a participação dos alunos. Oferecemos aulas individuais ou em grupos reduzidos, com no máximo quatro alunos, garantindo atenção personalizada e acompanhamento constante. Avaliamos regularmente os pontos fortes e os aspectos a desenvolver de cada estudante, promovendo o aprendizado dos idiomas de forma fluente e natural.
          </Information>
        </InfoCard>
      </InfoWrapper>
      <ButtonBottom>
        <a
          href="https://wa.me/5511999610535"
          target="blank"
          style={{
            textDecoration: "none",
            color: "white",
          }}
        >
          Clique para uma aula teste!
        </a>
      </ButtonBottom>
    </Container>
  );
}
